/* eslint-disable @typescript-eslint/no-unused-vars */

import { AppService } from '@/core/http/http-client'
import { userStore } from '@/core/stores/user'
import { jwtUtils } from './jwt'
import { GET_STORAGE } from '../storage'
import { StorageEnum } from '@/core/enums/storage.enum'

const isTokenExpiringSoon = (token: string) => {
  if (!token) return true

  try {
    const payloadStorage = GET_STORAGE(StorageEnum.TOKEN)
    if (payloadStorage != null) {
      const decodeLocalStorage = atob(payloadStorage)
      const decodeToken = jwtUtils.decodeToken(decodeLocalStorage)
      const expirationTime = decodeToken.exp * 1000
      const currentTime = Date.now()
      const timeUntilExpiration = expirationTime - currentTime
      // Retorna true si expira en menos de 5 minutos
      return timeUntilExpiration < 5 * 60 * 1000
    }
  } catch (error: unknown) {
    return true
  }
}

const refreshTokenIfNeeded = async () => {
  const userState = userStore()
  const http = new AppService()

  if (isTokenExpiringSoon(userState.token)) {
    try {
      const response = await http.refreshToken()
      if (response) {
        localStorage.setItem('token', JSON.stringify(btoa(response)))
      }
    } catch (error: unknown) {
      userState.logout()
    }
  }
}

export const startAuthCheck = () => {
  const userState = userStore()
  setInterval(() => {
    if (userState.isAuthenticated) {
      refreshTokenIfNeeded()
    }
  }, 60000) // Verificar cada minuto
}
